import { Input as AntInput, InputProps } from 'antd';
import React from 'react';

type InputFieldProps = {
  error?: string;
} & InputProps;

const Input = (props: InputFieldProps) => {
  return (
    <>
      <AntInput {...props} className="c-input" />
      {props.error && <span className="c-input__error">{props.error}</span>}
    </>
  );
};

export default Input;
